import { Box, Button } from "@mui/material"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { FloatFilter } from "../../../../../../components/filtersDrawer/floatFilter"
import { useStyles } from "./styles"
import { useLogbookContext } from "../../context"
import { DestinationsList } from "./components/destinationsList"
import { useTimeOut } from "../../../../../../hooks/timeOut"
import { returnQuery } from "../../../../../../utils/methods/returnQuery"
import { DestinationProps } from "./components/destination/types"
import { DestinationMarkMap } from "../shared/destinationMap/types"
import { DestinationMap } from "../shared/destinationMap"
import { BaseMenuClickDestination } from "../../../../../../components/baseMenu"
import { menuOptionsDestination } from "./menuOptions"
import { ConvertDestination, DeleteDestination, EditDestination } from "./types"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { SnackSimple } from "../../../../../../components"
import { ModalType, ObjectGeneric } from "../../../../../../utils/types/generals"
import { SnackbarTypes, Types } from "../../../../../../utils/enums/types"
import { CodeDeleteDestination, CodeEditDestination } from "../../../../../../service/logbook/response/deleteDestination"
import { InputModal } from "../shared/formActivity/create/components/inputModal"
import { MapActivity } from "../mapActivity"
import { getLocalStorage } from "../../../../../../utils/crud/crypt"
import { Local } from "../shared/formActivity/create/types"
import { RequestErrors, Roles, Status } from "../../../../../../utils/enums"
import { companiesServiceFetch } from "../../../../../../utils/constants/callService"
import { ConverDestination } from "../shared/convertDestination"
import { getTimeZone, getZones } from "../../../../../../utils/methods/geServiceWithItemsFormat"
import { useInitialValues } from "../shared/convertDestination/initialState"
import { statusService, UserService } from "../../../../../../service"
import { zipCodeService } from "../../../../../../service/zipcode"
import { httpFetch } from "../../../../../../utils/crud"


export const DestinationsRegistered = () => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [expandMap, setExpandMap] = useState(true)
    const [localLoad, setLocalLoad] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [oldFilterString, setOldFilterString] = useState('')
    const { executeFunction } = useTimeOut()
    const { filter: { filterDestinations }, service } = useLogbookContext()
    const [destinations, setDestinations] = useState<DestinationProps[]>([])
    const [idestinationsToView, setDestinationsToView] = useState<number[]>([])
    const [destinationsMark, setDestinationsMark] = useState<DestinationMarkMap[]>([])
    const [snackbar, setSnackbar] = useState({ open: false, message: '', type: SnackbarTypes.SUCCESS as string, })
    const [modal, setModal] = useState<ModalType>({ open: false, description: '', title: '' })
    const [openDestinatioModalRegitred, setOpenDestinatioModalRegistred] = useState(false)
    const [value, setValue] = useState<{ name: string, direction: string, company?: { label: string, value: number } }>({ name: '', direction: '', company: undefined })
    const company: Local = getLocalStorage()
    const [selectedPoint, setSelectedPoint] = useState<{ lat: number; lng: number } | null>(null);
    const [companies, setCompanies] = useState<{ id: number, value: number, label: string }[]>([]);
    const [idSelected, setIdSelected] = useState<number | undefined>(undefined)
    const [loader, setLoader] = useState(false)
    const [open, setOpen] = useState(false)
    const initialValues = useInitialValues()
    const [inputValues, setInputValues] = useState(initialValues)
    const [fatherList, setFatherList] = useState<any[]>([])
    const [childZones, setChildZones] = useState<any[]>([])

    const closeDrawer = () => {
        setOpen(false)
    }

    const filter = filterDestinations.filter
    const input = filterDestinations.input


    const changeExpandMap = () => {
        setExpandMap(prev => !prev)
    }

    const filterAll = () => {
        filter.cleanFilter()
        setPage(1)
    }

    const destinationsList = async () => {
        setLocalLoad(true)
        const response = await service.getDestinations({ query: returnQuery(filter.query) })
        setDestinations(response.data)
        setTotalPage(response?.total ?? 1)
        setLocalLoad(false)
    }

    const getCompnaies = async () => {
        const response = await companiesServiceFetch.getAllCompanies()

        if (!response.errors) {
            setCompanies(
                response?.map((item) => ({
                    label: item.name,
                    value: item.id,
                    id: item.id
                }))
            )
        }
    }

    const addOrDeleteDestinationToview = (id: number) => {
        setDestinationsToView(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id)
                : [...prev, id]
        )

        const destinationSelected = destinations.find(dest => dest.id === id);

        if (!destinationSelected) return;

        const [lat, lng] = destinationSelected?.latitudeAndLongitude.split(',').map(Number)

        setDestinationsMark(prev =>
            prev.some(item => item.id === id)
                ? prev.filter(item => item.id !== id)
                : [
                    ...prev,
                    {
                        companyName: destinationSelected.companyName,
                        createdDate: destinationSelected.createdDate,
                        direction: destinationSelected.direction,
                        id: destinationSelected.id,
                        lat: lat,
                        long: lng,
                        name: destinationSelected.name,
                        userCreator: destinationSelected.userCreator
                    }
                ]
        )
    }

    const seeAll = () => {

        const newIds = destinations
            .map(dest => dest.id)
            .filter(id => !idestinationsToView.includes(id))

        if (newIds.length) {
            setDestinationsToView(prev => [...prev, ...newIds])
        }

        const newMarks: DestinationMarkMap[] = destinations
            .filter(dest => !destinationsMark.some(mark => mark.id === dest.id))
            .map(dest => {
                const [lat, lng] = dest.latitudeAndLongitude.split(',').map(Number)

                return {
                    companyName: dest.companyName,
                    createdDate: dest.createdDate,
                    direction: dest.direction,
                    id: dest.id,
                    lat: lat,
                    long: lng,
                    name: dest.name,
                    userCreator: dest.userCreator
                }
            })

        if (newMarks.length) {
            setDestinationsMark(prev => [...prev, ...newMarks])
        }
    }

    const hiddenAll = () => {
        setDestinationsToView([])
        setDestinationsMark([])
    }

    function isOnlyPaginationChanged(prevQuery: string, newQuery: string): boolean {
        const parseQuery = (query: string) => {
            return Object.fromEntries(new URLSearchParams(query));
        };

        const prevParams = parseQuery(prevQuery);
        const newParams = parseQuery(newQuery);

        const keysToIgnore = ['page', 'size'];

        // Compara todos los filtros excepto page y size
        for (const key in prevParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        for (const key in newParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        return true; // Solo cambió page o size
    }

    const deleteDestination: DeleteDestination = async ({ id }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            description: t('loogbook.modal.deleteDestination'),
            title: t('general.confirm'),
            confirm: async () => {
                setModal(prev => ({ ...prev, loading: true }))
                const response = await service.deleteDestination({ id: id })
                setModal(prev => ({ ...prev, loading: false }))
                if (response.code == CodeDeleteDestination.SUCCESS) {
                    destinationsList()
                    closeModal()
                    setDestinationsToView(prev =>
                        prev.includes(id)
                            ? prev.filter(item => item !== id)
                            : [...prev]
                    )

                    setDestinationsMark(prev =>
                        prev.some(item => item.id === id)
                            ? prev.filter(item => item.id !== id)
                            : [...prev]
                    )
                    //setPage(1)
                    setSnackbar({ message: t('loogbook.snackbar.deleteDestination.success'), open: true, type: SnackbarTypes.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.deleteDestination.error'), open: true, type: SnackbarTypes.ERROR })
            },
            cancel: closeModal
        }))
    }

    const editDestination: EditDestination = async ({ companyId, companyName, direction, id, latitudeAndLongitude, name }) => {
        const [lat, lng] = latitudeAndLongitude.split(",");
        setSelectedPoint({ lat: Number(lat), lng: Number(lng) });
        setValue({ direction: direction, name: name, company: { label: companyName, value: companyId } })
        setOpenDestinatioModalRegistred(true)
        setIdSelected(id)
    }


    const handleEditDestination = async () => {
        if (idSelected) {

            const body = {
                namePlace: value.name,
                locationName: value.direction,
                latitude: selectedPoint?.lat,
                longitude: selectedPoint?.lng,
                companyId: value.company?.value
            }
            setLoader(true)

            const response = await service.updateDestination({ id: idSelected, body: body })

            setLoader(false)
            if (response.code == CodeEditDestination.SUCCESS) {
                destinationsList()
                closeInputModal()
                setIdSelected(undefined)
                setDestinationsMark(prev => {
                    const exists = prev.some(item => item.id === idSelected);

                    if (!exists) return prev;

                    return prev.map(item =>
                        item.id === idSelected
                            ? {
                                ...item,
                                companyName: String(value.company?.label),
                                direction: value.direction,
                                lat: Number(selectedPoint?.lat),
                                long: Number(selectedPoint?.lng),
                                name: value.name,
                                userCreator: company.fullName
                            }
                            : item
                    );
                });
                setSnackbar({ message: t('loogbook.snackbar.updateDestination.success'), open: true, type: SnackbarTypes.SUCCESS })
                return
            }
            setSnackbar({ message: t('loogbook.snackbar.updateDestination.error'), open: true, type: SnackbarTypes.ERROR })

        }
    }

    const handleConvert = async (body: ObjectGeneric) => {
        if (idSelected) {

            setLoader(true)

            const response = await service.convertInUnity({ id: idSelected, body: body })

            setLoader(false)
            if (response.code == CodeDeleteDestination.SUCCESS) {
                destinationsList()
                closeDrawer()
                setIdSelected(undefined)
                setSnackbar({ message: t('loogbook.snackbar.convertInUnity.success'), open: true, type: SnackbarTypes.SUCCESS })
                return
            } else {
                if (!!response.errors && response.errors[0].code == 'ERR_STORE_ALREADY_EXIST' as RequestErrors) {
                    setSnackbar({ message: t('loogbook.snackbar.convertInUnity.errorId'), open: true, type: SnackbarTypes.ERROR })
                } else {
                    setSnackbar({ message: t('loogbook.snackbar.convertInUnity.error'), open: true, type: SnackbarTypes.ERROR })
                }
            }



        }
    }

    const convertDestination: ConvertDestination = async ({ companyId, companyName, direction, id, latitudeAndLongitude, name }) => {
        const [lat, lng] = latitudeAndLongitude.split(",");
        setSelectedPoint({ lat: Number(lat), lng: Number(lng) });
        setValue({ direction: direction, name: name, company: { label: companyName, value: companyId } })
        setOpen(true)
        setIdSelected(id)
    }

    const goToOptions: BaseMenuClickDestination = (item, payload) => {
        menuOptionsDestination({ item, payload: payload ? { ...payload, deleteDestination, editDestination, converDestination: convertDestination } : undefined })
    }

    const handleMapClick = (lat: number, lng: number) => {
        setSelectedPoint({ lat, lng });
    };

    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        if (place?.geometry?.location) {
            setSelectedPoint({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
        }
    };

    const closeModal = () => {
        setModal({ description: '', open: false, title: '' })
    }

    const closeInputModal = () => {
        setOpenDestinatioModalRegistred(false)
    }

    const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

    useEffect(() => {
        executeFunction({
            execute: () => {
                destinationsList()
                setOldFilterString(filter.query.all ?? '')
                if (!isOnlyPaginationChanged(oldFilterString ?? '', filter.query.all ?? '')) {
                    setPage(1)
                }
            }
        })
    }, [filter.query.all])

    useEffect(() => {
        getCompnaies()
    }, [])

    const getStatus = async () => {
        const responseStatus = await statusService().statusList()
        let valideStatus: any[] = []

        responseStatus?.forEach((item: any) => {
            if ([Status.ACTIVE, Status.INACTIVE].includes(item.id)) {
                valideStatus.push({
                    value: item.id,
                    label: item.description,
                })
            }
        })

        setInputValues(prev => ({
            ...prev,
            status: {
                ...initialValues.status,
                items: valideStatus,
            },
        }))
    }

    const getZonesAll = async () => {
        const { fatherZones, childZones } = await getZones()
        if (!!fatherZones?.length) {
            setChildZones(childZones)
        }
    }

    const getServiceTimeZone = async () => {
        const { item } = await getTimeZone()
        if (!!item?.length) {
            setInputValues((prev) => ({
                ...prev,
                timeZone: {
                    ...prev.timeZone,
                    items: item,
                },
            }))
        }
    }

    const getZipCode = async () => {
        const responseStates = await zipCodeService(httpFetch).satesList()

        if (!responseStates?.errors) {
            const states = responseStates?.map((item: any) => ({
                label: item.state,
                value: item.codState,
            }))
            setInputValues(prev => ({
                ...prev,
                states: {
                    ...initialValues.states,
                    items: states,
                },
            }))
        }
    }

    const getCityByID = async (id?: number) => {
        const response = id ? await zipCodeService(httpFetch).cityList(id) : []
        setInputValues((prev) => ({
            ...prev,
            city: {
                ...prev.city,
                items: !response?.errors
                    ? response?.map((item) => ({
                        label: item.country,
                        value: item.id,
                    }))
                    : [],
            },
        }))
        return true
    }



    const getCompanyById = async (id?: number | null, fatherZone?: number) => {
        if (id) {
            const responseStoreManagers = await UserService(httpFetch).userByIds(id.toString(), Roles.STORE.toString())
            const responseCompany = await companiesServiceFetch.getCompanyById(id)
            let fatherL: any[] = []
            if (!responseStoreManagers.errors) {
                setInputValues((prev) => ({
                    ...prev,
                    userManageId: {
                        ...prev.userManageId,
                        items:
                            responseStoreManagers?.length > 0
                                ? responseStoreManagers?.map((item: any) => ({
                                    label: `${item.firstName ?? ''} ${item.lastName ?? ''}${item.curp ? ' / ' + item.curp : ''}`,
                                    value: item.id,
                                }))
                                : [],
                    },
                }))
            }
            if (!responseCompany.errors) {
                fatherL =
                    responseCompany?.companysZone
                        ?.filter((item) => item.zone)
                        ?.map((item) => ({
                            label: item?.zone?.name,
                            value: item?.zoneId,
                        })) ?? []
                setFatherList(fatherL)
                setInputValues((prev) => ({
                    ...prev,
                    divisions: {
                        ...prev.divisions,
                        items:
                            responseCompany?.companysDivision
                                ?.filter((item) => item.division)
                                ?.map((item) => ({
                                    label: item?.division?.description,
                                    value: item?.divisionId,
                                })) ?? [],
                    },
                    fatherZone: {
                        ...prev.fatherZone,
                        items:
                            responseCompany?.companysZone
                                ?.filter((item) => item.zone?.zoneInitId === null)
                                ?.map((item) => ({
                                    label: item?.zone?.name,
                                    value: item?.zoneId,
                                })) ?? [],
                    },
                }))
            }

            if (!!fatherZone) {
                setInputValues((prev) => ({
                    ...prev,
                    class: {
                        ...prev.class,
                        items:
                            childZones
                                .filter((item) => item.father === fatherZone && !!fatherL?.map?.((item) => item.value)?.includes(item.value))
                    },
                }))
            }
        } else {
            setInputValues((prev) => ({
                ...prev,
                divisions: {
                    ...prev.divisions,
                    items: [],
                },
                fatherZone: {
                    ...prev.fatherZone,
                    items: [],
                },
                class: {
                    ...prev.class,
                    items: [],
                },
                userManageId: {
                    ...prev.userManageId,
                    items: [],
                },
            }))
        }
        //setBtnLoading(false)
    }

    const getCompannies = async () => {
        if (!!company.company?.id) {
            getCompanyById(company.company?.id)
            setInputValues((prev) => {
                delete prev?.companyId
                return prev
            })
            return
        }
        const responseCompanies = await companiesServiceFetch.getAllCompanies()

        const companies = responseCompanies?.map((item) => ({
            label: item.name,
            value: item.id,
        }))

        setInputValues((prev) => ({
            ...prev,
            companyId: {
                ...initialValues.companyId,
                items: companies,
            },
        }))
    }

    const getData = useCallback(async () => {
        getStatus()
        getZonesAll()
        getServiceTimeZone()
        getZipCode()
        getCompannies()
    }, [])

    useEffect(() => {
        getData()
    }, [])



    return (
        <>
            <Box sx={styles.mainContainer}>
                <Box sx={styles.containerUser(expandMap)}>
                    <DestinationsList
                        loading={localLoad}
                        usersToView={idestinationsToView}
                        displayDestination={addOrDeleteDestinationToview}
                        hiddeAll={hiddenAll}
                        seeAll={seeAll}
                        manualPagination={{
                            changePagination: ({ page }) => {
                                filter.handlePagination({ page, pageSize: 20 })
                                setPage(page)
                            },
                            page,
                            totalPages: totalPage
                        }}
                        destinationsList={destinations}
                        menuOption={goToOptions}
                        //getActivities={activities}
                        changeExpandMap={changeExpandMap}
                        expandMap={expandMap}
                    />
                </Box>

                <Box sx={styles.map(expandMap)}>
                    <Box sx={styles.containerHidenButon}>
                        <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap')}</Button>
                    </Box>
                    <Box sx={styles.containerMap}>
                        <DestinationMap destinationMark={destinationsMark} />
                    </Box>
                </Box>


            </Box>

            <FloatFilter
                cleanFilter={filterAll}
                counter={filter.counter}
                onChange={filter.onChange}
                values={filter.filterData}
                input={input}
                filter={false}
            />
            <SimpleModal
                open={!!modal?.open}
                close={closeModal}
                title={modal?.title}
                description={modal?.description}
                cancelText={modal?.cancelText ?? t('general.cancel')}
                buttonText={modal?.confirmText ?? t('general.confirm')}
                back={modal?.cancel}
                isLoading={!!modal?.loading}
                loadingButton
                next={modal?.confirm ?? closeModal}
                sx={modal.sx}
                children={modal.children}
                removeButtons={modal.removeButtons}
            />
            <SnackSimple
                close={closeSnackbar}
                open={snackbar.open}
                type={snackbar.type as Types}
                message={snackbar.message}
            />

            <InputModal
                open={openDestinatioModalRegitred}
                title={undefined}
                cancelText={t('general.cancel')}
                buttonText={t('loogbook.titles.editDestination')}
                back={closeInputModal}
                next={() => { handleEditDestination() }}
                disableButton={(!company.company && !value.company && company.role == Roles.ADMIN) || value.direction.trim()?.length < 3 || value.name.trim()?.length < 3 || !selectedPoint}
                sx={styles.mapModal}
                isLoader
                loaderButton={loader}
                hideClose
                children={
                    <Box sx={styles.mapContainer}>
                        <MapActivity
                            defaultCenter={{ lat: selectedPoint ? selectedPoint.lat : 37.7749, lng: selectedPoint ? selectedPoint.lng : -122.4194 }}
                            defaultZoom={14}
                            selectedPoint={selectedPoint}
                            onMapClick={handleMapClick}
                            onPlaceSelect={handlePlaceSelect}
                            value={value}
                            setValue={setValue}
                            compnayId={company.company?.id}
                            role={company.role}
                            companies={companies}
                            title={t('loogbook.titles.editDestination')}
                        />
                    </Box>
                }
            />

            {open && <ConverDestination
                open={open}
                inputValues={inputValues}
                childZones={childZones}
                fatherList={fatherList}
                getCityByID={getCityByID}
                getCompanyById={getCompanyById}
                setInputValues={setInputValues}
                closeDrawer={closeDrawer}
                selectedPoint={selectedPoint}
                value={value}
                handleConvert={handleConvert}
                loader={loader}
            />}
        </>
    )
}